export type FetchGate = { current: boolean };

export const GRANT_FAILED_MESSAGE = 'Logto access token was empty or the grant failed.';

export function shouldStartInitialResolve(isAuthenticated: boolean, fetching: boolean): boolean {
  return Boolean(isAuthenticated) && !fetching;
}

export function beginInitialResolve(gate: FetchGate): void {
  gate.current = true;
}

export function releaseInitialResolveGate(gate: FetchGate): void {
  gate.current = false;
}

/** Cancelled remounts must still drop tokenLoading so the splash cannot stick. */
export function tokenLoadingAfterInitialResolveSettle(): false {
  return false;
}

export function shouldResolveSessionAfterTokenSettle(cancelled: boolean): boolean {
  return !cancelled;
}

export function isMissingAccessToken(token: string | undefined | null): boolean {
  return token == null || token === '';
}

export function hasAccessToken(token: string | undefined | null): token is string {
  return !isMissingAccessToken(token);
}
